import { useMemo } from "react";
import calcProgressBySchema from "../helpers/calcProgressBySchema";

const useCalcTotalProgress = ({ stepsSchema, data }) =>
  useMemo(() => calcProgressBySchema(data, stepsSchema), [stepsSchema, data]);

export default useCalcTotalProgress;
